import { useMemo } from 'react'
import dayjs from 'dayjs'
import { useMonthlyCustomersEarningsQuery } from 'hooks/queries/Rewards/useMonthlyCustomersEarningsQuery'
import { MonthlyCustomersEarnings } from 'types/rewards'
import { EmbeddedEarningTimePeriodValue } from '../constants/embeddedEarningTimePeriods'
import { RewardsDataPoint } from '../types'

const getDateRange = (months: number) => {
  const endDate = dayjs()
  const startDate = endDate.subtract(months, 'month')

  return {
    startDate: startDate.format('YYYY-MM-DD'),
    endDate: endDate.format('YYYY-MM-DD'),
  }
}

const toRewardsDataPoint = (earning: MonthlyCustomersEarnings): RewardsDataPoint => {
  const monthYear = dayjs(earning.earningsPeriodEnd).format('MMM YYYY')

  return {
    day: earning.earningsPeriodEnd,
    rewards: Number.parseFloat(earning.amount),
    tooltipLabel: monthYear,
  }
}

export const useMonthlyCustomersEarnings = (
  timePeriod: EmbeddedEarningTimePeriodValue,
  currency: string
) => {
  const { startDate, endDate } = getDateRange(Number(timePeriod))

  const { data: monthlyEarnings, isLoading } = useMonthlyCustomersEarningsQuery({
    currency,
    startDate,
    endDate,
    pageSize: 25,
    pageNumber: 0,
  })

  const rewardsData = useMemo(() => {
    if (!monthlyEarnings?.content) return []
    return monthlyEarnings.content.map(toRewardsDataPoint).reverse()
  }, [monthlyEarnings])

  return {
    rewardsData,
    isLoading,
  }
}
